/* ─── Naire Landing · vanilla JS para Shopify ─── */
(function () {
  'use strict';

  // Las 10 secciones naire-* de la home incluyen este mismo <script src> cada una.
  // Un <script src> repetido NO se deduplica: se ejecuta una vez por etiqueta.
  // Sin este guardia se montaban 20 IntersectionObserver y cada video del landing
  // recibia 10 observers llamandole play()/pause() a la vez. 06-09-2026.
  if (window.__naireLandingReady) return;
  window.__naireLandingReady = true;

  // Solo las primeras secciones despues del hero: el hero esta sobre el pliegue
  // y su contenido tiene que verse instantaneo.
  var SECCIONES_REVEAL = ['naire_02', 'naire_03', 'naire_04'];

  var PIEZAS = [
    '.naire-eyebrow',
    'h2',
    '.naire-body-text',
    '.naire-econ-punch',
    '.naire-claim',
    '.naire-stat',
    '.naire-symptom',
    '.naire-photo',
    '.naire-econ-closer',
    '.naire-cta'
  ];

  function menosMovimiento() {
    return window.matchMedia &&
           window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Las clases se ponen desde JS a proposito: el estado por defecto de
  // .naire-reveal es opacity:0, asi que si esto no corre nadie esconde nada.
  // Con la clase en el markup, un fallo de JS dejaria el contenido invisible.
  function marcarPiezas() {
    if (menosMovimiento()) return [];

    var marcados = [];
    SECCIONES_REVEAL.forEach(function (clave) {
      var secciones = document.querySelectorAll('[id*="' + clave + '"]');
      Array.prototype.forEach.call(secciones, function (sec) {
        var n = 0;
        PIEZAS.forEach(function (sel) {
          Array.prototype.forEach.call(sec.querySelectorAll(sel), function (el) {
            if (el.classList.contains('naire-reveal')) return;
            // naire-noanim entra primero: el salto al estado oculto tiene que
            // ser instantaneo, si no el elemento hace un fade-OUT de 0,8s
            // antes de poder entrar.
            el.classList.add('naire-noanim', 'naire-reveal');
            n += 1;
            if (n <= 5) el.classList.add('naire-d' + n);
            marcados.push(el);
          });
        });
      });
    });

    // Dos frames: uno para que el navegador aplique el estado oculto sin
    // transicion, otro para devolver la transicion antes de que entre nada.
    if (marcados.length) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          marcados.forEach(function (el) { el.classList.remove('naire-noanim'); });
        });
      });
    }
    return marcados;
  }

  // El ambito de un control es SU seccion, no la primera de la pagina: dos
  // secciones distintas pueden repetir nombres de tab, y el FAQ tiene que
  // cerrar solo a sus hermanas.
  function ambitoDe(el) {
    return (el.closest && el.closest('.naire-landing')) || document;
  }

  function init() {
    // Antes esto arrancaba con
    //   var root = document.querySelector('.naire-landing');
    // y despues buscaba tabs, FAQ y videos con root.querySelectorAll(...).
    // root es solo la PRIMERA .naire-landing del documento y cada seccion
    // Naire monta la suya (en la home hay 15), asi que los controles de la
    // segunda seccion en adelante nunca recibian un listener: el FAQ, que es
    // la seccion 10, no se desplegaba y solo se veia abierta la fila que el
    // Liquid marca fija con naire-open. Es el mismo bug que ya estaba anotado
    // mas abajo para el reveal, que si se habia corregido. 07-09-2026.
    if (!document.querySelector('.naire-landing')) return;

    // Tabs
    var tabBtns = document.querySelectorAll('[data-naire-tab]');
    Array.prototype.forEach.call(tabBtns, function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-naire-tab');
        var ambito = ambitoDe(btn);
        Array.prototype.forEach.call(ambito.querySelectorAll('[data-naire-tab]'), function (b) {
          b.classList.remove('naire-active');
        });
        Array.prototype.forEach.call(ambito.querySelectorAll('[data-naire-panel]'), function (p) {
          p.classList.remove('naire-active');
        });
        btn.classList.add('naire-active');
        var panel = ambito.querySelector('[data-naire-panel="' + target + '"]');
        if (panel) panel.classList.add('naire-active');
      });
    });

    // FAQ accordion
    var faqRows = document.querySelectorAll('[data-naire-faq]');
    Array.prototype.forEach.call(faqRows, function (row) {
      var btn = row.querySelector('.naire-faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var ambito = ambitoDe(row);
        var hermanas = ambito.querySelectorAll('[data-naire-faq]');
        var isOpen = row.classList.contains('naire-open');
        Array.prototype.forEach.call(hermanas, function (r) { r.classList.remove('naire-open'); });
        if (!isOpen) row.classList.add('naire-open');
      });
    });

    // Autoplay videos on scroll (muted required by browsers)
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            v.muted = true;
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function(){});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.5 });
      Array.prototype.forEach.call(document.querySelectorAll('video[data-naire-autoplay]'), function (v) {
        v.muted = true;
        v.setAttribute('muted', '');
        vio.observe(v);
      });
    }

    // Reveal-on-scroll.
    // Antes usaba root.querySelectorAll, y root es solo la PRIMERA
    // .naire-landing del documento: cada seccion Naire monta la suya, asi que
    // de la segunda en adelante nunca se observaba nada. Ahora barre el
    // documento entero.
    marcarPiezas();
    var candidatos = document.querySelectorAll('.naire-reveal');
    if (!candidatos.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('naire-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12 });
      Array.prototype.forEach.call(candidatos, function (el) { io.observe(el); });

      // Lo que ya este en pantalla al cargar se revela igual: sin esto un
      // bloque visible desde el arranque puede quedarse esperando un scroll
      // que nunca llega.
      setTimeout(function () {
        Array.prototype.forEach.call(candidatos, function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('naire-in');
        });
      }, 500);
    } else {
      Array.prototype.forEach.call(candidatos, function (el) { el.classList.add('naire-in'); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();